module.exports = __webpack_public_path__ + "media/images/advisers/img_ogura-7fa069dae2a44df58d771e664860ab9a.jpg";